import * as React from "react";
import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

interface Props {
    className?: string;
}

export const CaseConversationDocumentText = (props: Props) => {
    const caseConversationDocumentText = getFeatureToggles()[FeatureToggleNames.CaseConversationDocumentText];

    if (!caseConversationDocumentText) {
        return <></>;
    }

    return (
        <div className={props.className ?? ""}>
            Please note, documents added to case conversations will show in the documents tab within the case
        </div>
    );
};
